module.exports = __webpack_public_path__ + "media/components/maps/incidents/icons/violent_crime-cf82cd7dc045bccb8ef8481ab152a729.png";